import { fetchTodayWorkLog } from '../api/worklogApi';
import { useToastStore } from '@/shared/lib/toast';
import { isFeatureActive } from '@/shared/config';

/**
 * Create a pre-checkout validator that warns MEMBERs who haven't submitted today's work log.
 * Returns `true` always — the warning is non-blocking (checkout proceeds regardless).
 * today 피처(work-log 종속)가 비활성(teaser/hidden)이면 validator를 생성하지 않는다.
 */
export function createCheckOutValidator(
  teamRole: string | undefined
): (() => Promise<boolean>) | undefined {
  if (!isFeatureActive('today')) return undefined;
  if (teamRole !== 'MEMBER') return undefined;

  return async () => {
    try {
      const todayLog = await fetchTodayWorkLog();
      if (!todayLog || todayLog.status === 'DRAFT') {
        useToastStore.getState().addToast({
          title: '업무일지를 제출하지 않으셨습니다',
          type: 'warning',
        });
      }
    } catch {
      // 업무일지 조회 실패해도 퇴근은 진행
    }
    return true;
  };
}
